// extracted by mini-css-extract-plugin
export var footerContainer = "z_b0";
export var footerContent = "z_b2";
export var footerDisclosure = "z_b3";
export var menu = "z_b1";